module.exports = __webpack_public_path__ + "img/acquire.1227d40b.png";